/**
 * Legal-document version strings — shared between server + client.
 *
 * Source of truth for:
 *   - J-X13 — Privacy + ToS acceptance (sign-up handler stamps these onto
 *     `users.tos_version_accepted` / `users.privacy_version_accepted`;
 *     middleware compares stored vs. current on every request; blocking
 *     modal triggers when stale).
 *   - J-X14 — Cookie policy version (informational; cookie_consent cookie
 *     is the source of consent state).
 *   - J-X20 — Integrity pledge (stamped onto `attempts.integrity_pledge_version`
 *     at Begin Test).
 *
 * Bump a version string whenever the corresponding document changes
 * materially — that re-prompts existing users on their next request via the
 * stale-consent modal (J-X13 § Steps existing user). Cosmetic/typo fixes
 * MAY keep the same version; substantive policy changes MUST bump.
 *
 * Lives in `@bimassess/db` so both `packages/web` (client) and
 * `packages/api` + `src/modules` (server) import a single constant.
 * Re-exported through `@bimassess/db` barrel.
 */

export const TOS_VERSION = '2026-05-28';
export const PRIVACY_VERSION = '2026-05-28';
export const COOKIES_VERSION = '2026-05-28';
export const INTEGRITY_PLEDGE_VERSION = '2026-05-28';

/**
 * Verbatim integrity-pledge body shown to candidates above the Begin Test
 * button. Source of truth: `docs/legal/integrity-pledge.md`. Kept inline
 * here so the FE doesn't ship a markdown parser purely for this string;
 * when react-markdown is added (or markdown bundling lands) this constant
 * can be replaced with a `?raw` import of the .md file.
 */
export const INTEGRITY_PLEDGE_BODY = [
  'I affirm that:',
  '- I am the person named on this account.',
  '- I will complete this test using only my own knowledge, without assistance from other people or unauthorised reference material.',
  '- I will not share questions or answers with others.',
  '- I understand that violations may result in my result being voided and my account being suspended.',
].join('\n');
